import React from 'react'

export default function pdfConverter(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <g clip-path="url(#a)" fill="currentColor">
          <path d="M31.2 5.8 26 .7c-.4-.4-1.1-.7-1.8-.7H8.6C6.9 0 5.5 1.3 5.5 3v16.8c.3-.1.7-.1 1-.2V3c0-1.1.9-2 2-2h15.7c.4 0 .8.2 1.1.4l5.2 5.1c.3.3.5.7.5 1.1V29c0 1.1-.9 2-2 2H16.3c-.1.3-.2.7-.4 1h13c1.7 0 3.1-1.3 3.1-3V7.6c0-.7-.3-1.3-.8-1.8" />
          <path
            d="M30.6 6.2 25.3.9c-.3-.3-.7-.5-1.1-.5h-16c-1.1 0-2.1.9-2.1 2.1l-.2 17.2h1.3c5.2 0 9.3 4.2 9.3 9.4 0 .9-.1 1.7-.4 2.6H29c1.1 0 2.1-.9 2.1-2.1V7.3c0-.4-.2-.8-.5-1.1"
            opacity=".1"
          />
          <path d="m16.1 26.1-.4-1h7.4c.2 0 .4.2.4.5s-.2.5-.4.5zm10.6-3.6c.4 0 .5.2.5.5s-.1.5-.5.5H14.8l-.9-1zM14 8.4c1.7-1 3.1-2.2 3-3.8-.1-.2-.7-1-.8-1.3l-3.3 2.5z" />
          <path d="M16.5 7.5c.1-.4.3-.9.5-1.4V6c0 .1-.3.6-.4.8-.2.3-.4.6-.7.8-.9 1-4.1 2.5-5.2 3.2l.9 3.8 2.2-.8c.2-.2.6-.5.9-.9.2-.3.1-.2.2-.3zm9.9.5L22 3.6c-.4.3-3 1.6-3.9 2.5-1 .9-3.1 7.3-2.9 7.8.2-.5.6-1 1.1-1.5.3-.3.7-.5 1-.7z" />
          <path d="M21.5 16.6c-1.9.4-3.7.8-5.6 1.2-.1-.3-.3-.8-.5-1.1-.2-.4-.4-.9-.3-1.3 0-1.3 1-2.3 2.1-2.9.2-.1 1.4-.8 1.5-.6-.2-.7 1.7 2.8 2.8 4.7M7.5 21C3.4 21 0 24.4 0 28.5S3.4 36 7.5 36s7.5-3.4 7.5-7.5S11.6 21 7.5 21m4.6 7.7-4.2 3.8q-.15.15-.3 0l-.1-.1V30H4c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h3.5v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9z" />
          <path
            d="M7.8 33.94c2.673 0 4.84-2.337 4.84-5.22S10.473 23.5 7.8 23.5s-4.84 2.337-4.84 5.22 2.167 5.22 4.84 5.22"
            opacity=".1"
          />
        </g>
      </svg>
    </div>
  )
}
